/* import React from 'react';
import SideMenuWidget from '../Widget/SideMenuWidget';
import RecentPostWidget from '../Widget/RecentPostWidget';
import NewsletterStyle5 from '../Widget/NewsletterStyle5';
const categoryData = [
  {
    title: 'Health Tips and Tricks',
    url: '/',
  },
  {
    title: 'Trends and Analysis',
    url: '/',
  },
  {
    title: 'Time Management',
    url: '/',
  },
];
const recentPostData = [
  {
    title: `A Parent's Guide to Childhood Vaccinations: What You Need to Know`,
    author: 'James Brown',
    date: 'August 10, 2023',
    href: '/blog/blog-details',
  },
  {
    title: `Preventing Heart Disease: Tips for a Heart-Healthy Lifestyle`,
    author: 'James Brown',
    date: 'August 09, 2022',
    href: '/blog/blog-details',
  },
  {
    title: `Managing Chronic Pain: Treatment Options and Strategies`,
    author: 'James Brown',
    date: 'August 08, 2022',
    href: '/blog/blog-details',
  },
  {
    title: `The Role of Physical Therapy in Injury Recovery and Prevention`,
    author: 'James Brown',
    date: 'August 07, 2022',
    href: '/blog/blog-details',
  },
  {
    title: `Allergies and Asthma: Causes, Symptoms, and Treatment Options`,
    author: 'James Brown',
    date: 'August 10, 2023',
    href: '/blog/blog-details',
  },
];

export default function Sidebar() {
  return (
    <div className="cs_sidebar">
      <div className="cs_sidebar_item widget_categories">
        <SideMenuWidget title="Popular Categories" data={categoryData} />
      </div>
      <div className="cs_sidebar_item">
        <RecentPostWidget title="Popular Articles" data={recentPostData} />
      </div>
      <div className="cs_sidebar_item widget_categories">
        <NewsletterStyle5 title="Newsletter Sign Up Form" />
      </div>
    </div>
  );
}
 */

import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

import SideMenuWidget from '../Widget/SideMenuWidget';
import RecentPostWidget from '../Widget/RecentPostWidget';
import NewsletterStyle5 from '../Widget/NewsletterStyle5';

export default function Sidebar() {
  const [categoryData, setCategoryData] = useState([]);
  const [recentPostData, setRecentPostData] = useState([]);

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        const q = query(collection(db, 'blogs'), orderBy('publishAt', 'desc'));
        const snapshot = await getDocs(q);
        const allBlogs = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            title: data.title,
            author: data.author || 'Staff Writer',
            date: data.publishAt
              ? new Date(data.publishAt).toLocaleDateString()
              : 'TBA',
            category: data.category || 'Uncategorized',
          };
        });

        // Recent posts
        setRecentPostData(
          allBlogs.slice(0, 5).map((post) => ({
            title: post.title,
            author: post.author,
            date: post.date,
            href: `/blog/${post.id}`,
          }))
        );

        // Unique sorted categories
        const categorySet = new Set(allBlogs.map((post) => post.category));
        const categories = Array.from(categorySet)
          .sort()
          .map((cat) => ({
            title: cat,
            url: `/blog?category=${encodeURIComponent(cat)}`,
          }));
        setCategoryData(categories);
      } catch (error) {
        console.error('⚠️ Error fetching blog data:', error);
      }
    };

    fetchBlogData();
  }, []);

  return (
    <div className="cs_sidebar">
      <div className="cs_sidebar_item widget_categories">
        <SideMenuWidget title="Popular Categories" data={categoryData} />
      </div>
      <div className="cs_sidebar_item">
        <RecentPostWidget title="Popular Articles" data={recentPostData} />
      </div>
{/*       <div className="cs_sidebar_item">
        <NewsletterStyle5 title="Newsletter Sign Up Form" />
      </div> */}
    </div>
  );
}
